import React, { useState, useEffect } from 'react';
import { generateStructuredData } from '../../../utils/seo';

export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '初回相談は無料ですか？',
      answer: 'はい、初回相談は30分まで無料でお受けしております。お気軽にご相談ください。'
    },
    {
      question: '相続登記はいつまでに行う必要がありますか？',
      answer: '2024年4月1日より相続登記が義務化され、相続を知った日から3年以内に登記申請を行う必要があります。'
    },
    {
      question: '会社設立にはどのくらいの期間がかかりますか？',
      answer: '必要書類が揃ってから約1〜2週間程度で設立登記が完了します。事前準備を含めると1ヶ月程度見ていただくことをお勧めします。'
    },
    {
      question: '債務整理の相談は秘密が守られますか？',
      answer: 'はい、司法書士には守秘義務がありますので、ご相談内容が外部に漏れることは一切ありません。安心してご相談ください。'
    },
    {
      question: '土日祝日の相談は可能ですか？',
      answer: '通常は平日9:00〜18:00の営業ですが、事前にご予約いただければ土日祝日のご相談も承ります。'
    },
    {
      question: '費用の分割払いは可能ですか？',
      answer: 'ご事情に応じて分割払いのご相談も承っております。まずはお気軽にご相談ください。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    // Add FAQ structured data to the page
    const faqStructuredData = generateStructuredData.faq(faqs);
    const existingFaqScript = document.querySelector('script[data-faq="true"]');
    if (existingFaqScript) {
      existingFaqScript.remove();
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq', 'true');
    script.textContent = JSON.stringify(faqStructuredData);
    document.head.appendChild(script);
  }, []);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">よくある質問</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            お客様からよくいただくご質問をまとめました。
            その他のご質問がございましたら、お気軽にお問い合わせください。
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-3 md:mb-4 border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full px-4 md:px-6 py-3 md:py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex items-center justify-between"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-sm md:text-lg font-semibold text-gray-900 pr-3 md:pr-4 leading-snug">{faq.question}</h3>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl md:text-2xl text-blue-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-6 py-3 md:py-4 bg-white">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
